import client from './axiosInstance';

export const fetchProjectsFilterList = async () => {
  return await client.get(`/projects/base/projects`);
};
